import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  Icon,
} from '@st-operations/uikit/src/v2/index.js'

import CustomAttributeMenuItem from './custom-attribute-menu-item/index.jsx'
import useCustomAttributesCRUD from '../useCustomAttributesCRUD'
import CustomAttributesForm from '../custom-attributes-form/index.jsx'

import './styles.scss'

const MODAL_STYLES = {
  content: 'add-custom-attributes-modal__container',
  childWrapper: 'add-custom-attributes-modal__wrapper',
  innerWrapper: 'add-custom-attributes-modal__inner-wrapper',
  headerClose: 'add-custom-attributes-modal__close-button',
}

const ModalAddCustomAttributes = ({ isOpen, onClose }) => {
  const {
    handleSaveChanges,
    handleAdd,
    handleEdit,
    handleRemove,
    handleSelect,
    selectedTabIndex,
    isLoading,
    customAttributes = [],
  } = useCustomAttributesCRUD({
    onSave: onClose,
  })

  return (
    <Modal isOpen={isOpen} onClose={onClose} classes={MODAL_STYLES}>
      <section className="add-custom-attributes-modal__content">
        <header className="add-custom-attributes-modal__header">
          <h1 className="add-custom-attributes-modal__header-title">Add Custom Attributes</h1>

          <Button
            theme={BUTTON_THEME.GHOST}
            size={BUTTON_SIZE.SMALL}
            onClick={handleAdd}
            className="add-custom-attributes-modal__header-button"
          >
            <div className="add-custom-attributes-modal__button-filter">
              <Icon width="18px" height="18px" icon="add" type="fill" color="currentColor" />
              Add New Custom Attribute
            </div>
          </Button>
        </header>
        <div className="add-custom-attributes-modal__filters">
          <nav className="add-custom-attributes-modal__menu">
            <Choose>
              <When condition={customAttributes.length > 0}>
                <ul className="add-custom-attributes-modal__menu-list">
                  <For each="customAttribute" index="index" of={customAttributes}>
                    <li key={index} className="add-custom-attributes-modal__menu-item">
                      <CustomAttributeMenuItem
                        id={index}
                        name={customAttribute.alias}
                        isSelected={selectedTabIndex === index}
                        onClick={handleSelect}
                        onDelete={handleRemove}
                      />
                    </li>
                  </For>
                </ul>
              </When>
              <Otherwise>
                <p className="add-custom-attributes-modal__empty-menu">
                  Start adding your custom attributes and they will appear here
                </p>
              </Otherwise>
            </Choose>
          </nav>
          <div className="add-custom-attributes-modal__form">
            <Choose>
              <When condition={customAttributes.length > 0}>
                <CustomAttributesForm
                  key={selectedTabIndex}
                  id={selectedTabIndex}
                  value={customAttributes[selectedTabIndex]}
                  onChange={(value) => handleEdit(selectedTabIndex, value)}
                />
              </When>
              <Otherwise>
                <div className="add-custom-attributes-modal__empty">
                  <img src="../../../../../../static/img/Empty.svg" />
                  <p className="add-custom-attributes-modal__no-filters">
                    No custom attributes yet
                  </p>
                </div>
              </Otherwise>
            </Choose>
          </div>
        </div>
        <footer className="add-custom-attributes-modal__footer">
          <Button
            isLoading={isLoading}
            className="add-custom-attributes-modal__footer-button"
            onClick={handleSaveChanges}
          >
            Save Changes
          </Button>
        </footer>
      </section>
    </Modal>
  )
}

ModalAddCustomAttributes.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

ModalAddCustomAttributes.defaultProps = {
  isOpen: false,
  onClose: () => {},
}

export default React.memo(ModalAddCustomAttributes)
